module.exports = __webpack_public_path__ + "img/animals_wolf.24b4287c.png";